import React from "react";
import getDocs from "../../../services/Documents/getDocsData";
import { Info, Upload, X, FileText } from "lucide-react";
import signDoc from "../../../services/Documents/signDoc";

export const SignPdfModal = ({
  setCertFile,
  setUploadStatus,
  setKeyFile,
  certFile,
  keyFile,
  selectedDocument,
  setDocuments,
  closeModal,
  uploadStatus,
  userId,
  parentFolderId,
}) => {
  const handleCertFileChange = (e) => {
    if (e.target.files[0]) {
      setCertFile(e.target.files[0]);
      setUploadStatus("");
    }
  };

  const handleKeyFileChange = (e) => {
    if (e.target.files[0]) {
      setKeyFile(e.target.files[0]);
      setUploadStatus("");
    }
  };

  const handleSignSubmit = async (e) => {
    e.preventDefault();

    if (!certFile || !keyFile) {
      setUploadStatus("Please select both certificate and key files");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("cert", certFile);
      formData.append("key", keyFile);

      setUploadStatus("Processing signature...");
      const signDocResponse = await signDoc(userId, selectedDocument.metadataId.name, formData, parentFolderId);

      if (signDocResponse) {
        setUploadStatus("Document signed successfully");

        setTimeout(async () => {
          const docs = await getDocs(userId);
          setDocuments(docs);
          closeModal();
        }, 1500);
      } else {
        setUploadStatus("Failed to sign document");
      }
    } catch (error) {
      console.error("Error signing document:", error);
      setUploadStatus("An error occurred while signing the document");
    }
  };

  return (
    <div className="fixed inset-0 bg-[#1A365D] bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-2xl border-4 border-[#D4AF37] relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-1 bg-[#D4AF37]"></div>
        <button
          onClick={closeModal}
          className="absolute top-4 right-4 text-[#1A365D] hover:text-[#D4AF37] transition duration-300"
        >
          <X size={24} />
        </button>

        <div className="p-6">
          <h3 className="text-2xl font-bold mb-6 text-[#1A365D] flex items-center">
            <FileText className="mr-3 text-[#D4AF37]" size={28} />
            Firmar Documento
          </h3>

          <div className="mb-6 p-5 bg-gray-50 rounded-lg border-l-4 border-[#1A365D]">
            <div className="flex items-center mb-3">
              <Info size={20} className="text-[#D4AF37] mr-2" />
              <h4 className="font-semibold text-[#1A365D]">Detalles del Documento</h4>
            </div>
            <div className="text-sm text-gray-700">
              <p>
                <strong className="text-[#1A365D]">Nombre:</strong> {selectedDocument.title}
              </p>
              <p>
                <strong className="text-[#1A365D]">Fecha:</strong>{" "}
                {new Date(selectedDocument.CreatedAt).toLocaleDateString()}
              </p>
              <p>
                <strong className="text-[#1A365D]">ID:</strong> {selectedDocument._id}
              </p>
              {selectedDocument.isSigned && (
                <p className="text-[#D4AF37] font-medium mt-2 flex items-center">
                  Este documento ya está firmado
                </p>
              )}
            </div>
          </div>

          <form onSubmit={handleSignSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-[#1A365D] mb-2">
                Archivo de Certificado (.cert)
              </label>
              <div className="flex items-center">
                <input
                  type="file"
                  accept=".cert"
                  onChange={handleCertFileChange}
                  className="w-full px-3 py-2 border border-[#1A365D] border-opacity-30 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
                />
              </div>
              {certFile && (
                <p className="mt-1 text-sm text-gray-600">
                  Seleccionado: {certFile.name}
                </p>
              )}
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-[#1A365D] mb-2">
                Archivo de Clave Privada (.key)
              </label>
              <div className="flex items-center">
                <input
                  type="file"
                  accept=".key"
                  onChange={handleKeyFileChange}
                  className="w-full px-3 py-2 border border-[#1A365D] border-opacity-30 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
                />
              </div>
              {keyFile && (
                <p className="mt-1 text-sm text-gray-600">
                  Seleccionado: {keyFile.name}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={selectedDocument.isSigned}
              className={`w-full py-3 px-4 rounded-md font-semibold transition duration-300 ease-in-out transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#D4AF37] flex items-center justify-center ${
                selectedDocument.isSigned
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#1A365D] hover:bg-[#0F2240] text-white"
              }`}
            >
              <Upload size={20} className="mr-2" />
              Firmar Documento
            </button>
          </form>

          {uploadStatus && (
            <div
              className={`mt-4 p-3 rounded-md text-center font-medium ${
                uploadStatus.includes("successfully")
                  ? "bg-green-100 text-green-800"
                  : uploadStatus.includes("Failed") ||
                    uploadStatus.includes("Please select") ||
                    uploadStatus.includes("error")
                  ? "bg-red-100 text-red-800"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              {uploadStatus}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};